import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function UsingVoiceAuth () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'Using Voice Call Authentication', href: '/login-help/using-voice-auth' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Voice Call Authentication</h2>

      <Card>
        <CardBody>
          <p>
            Tap the <b>Call</b> button.
            On your mobile device, you will receive a phone call.
            Enter the code from the automated message, then tap <b>Verify</b> to complete the authentication process.
          </p>
          <img className='mb-4' src='/static/img/using-voice-auth.png' alt='using voice authentication' />
        </CardBody>
      </Card>
    </>
  )
}

UsingVoiceAuth.publicAccess = true

UsingVoiceAuth.getInitialProps = () => ({
  title: 'MFA Using Voice Call'
})

export default UsingVoiceAuth
